// extracted by mini-css-extract-plugin
module.exports = {"container":"Cart_container__OQpnj","cartTitle":"Cart_cartTitle__iDZwX","cart":"Cart_cart__YZPb0","checkout":"Cart_checkout___Fdex"};